<template>
    <div class="copy-to-clipboard">
        <button class="pure-button" @click="copySignature(site)">Copy Signature</button>
        <span v-if="copyMessage.length" :class="['message', copyError && 'error', !copyError && 'success', showMessage && 'show']">{{copyMessage}}</span>
    </div>
</template>

<script>
import { setTimeout } from 'timers';
export default {
    props: {
        site: String
    },
    data: function() {
        return {
            copyMessage: '',
            copyError: false,
            showMessage: false
        }
    },
    methods: {
        copySignature(site) {
            this.clearMessage();
            
                // seems necessary, otherwise you have to click the button twice to copy
                window.getSelection().removeAllRanges();
                const textToSelect = document.getElementById(site);
                const range = document.createRange();
                range.selectNode(textToSelect);
                window.getSelection().addRange(range);
                try {
                    const successful = document.execCommand('copy');
                    this.copyMessage = successful ? 'Copied!' : 'Copy unsuccessful, try again.';
                    this.copyError = !successful;
                    this.showMessage = true;
                } catch(err) {
                    // eslint-disable-next-line no-console
                    console.log('Copy error', err);
                    this.copyError = true;
                    this.copyMessage = 'Copy unsuccessful, try again.'
                    this.showMessage = true;
                }
                    
                // Remove the selections - NOTE: Should use   
                // removeRange(range) when it is supported  
                window.getSelection().removeAllRanges();

                // There seems to be a race condition with the CSS transition where
                // the message will only appear once even if the button is click
                // again. This waits for the same amount of time as the transition
                // and then resets everything.
                const self = this;
                setTimeout(function() {
                    self.clearMessage();
                }, 3000);
                
        },
        clearMessage() {
            this.copyMessage = '';
            this.copyError = false;
            this.showMessage = false;

        }
    }
}
</script>

<style scoped>
    @import url('https://unpkg.com/purecss@1.0.0/build/pure-min.css');
    .copy-to-clipboard {
        position: relative;
    }

    button {
        color: rgba(0,0,0,.5);
        float: right;
        margin-right: 10px;
        opacity: .5;
    }

    button:hover {
        color: rgba(0,0,0,.8);
        opacity: 1;
    }

    .message {
        font-size: 13px;
        padding: 5px 0;
        position: absolute;
        right: 10px;
        text-align: center;
        top: 40px;
        width: 140px;
    }

    .message.show {
        color: #FFFFFF;
        opacity: 1;
        text-align: center;

        animation: fadeinout 3s linear forwards;
    }

    @keyframes fadeinout {
        0%,100% { opacity: 0; }
        50% { opacity: 1; }
    }

    .success,
    .error {
        color: #fff;
    }

    .success {
        background-color: #5eb95e;
    }

    .error {
        background-color: #dd514c;
    }

    @media (max-width: 640px) {
        button {
            float: none;
            margin-bottom: 10px;
        }
    }
</style>


